import { enqueueSnackbar } from 'notistack';
import { snackbarConstants } from 'constants/SnackbarConstants';
import { API } from './api';
import Decimal from 'decimal.js';
import { t } from 'i18next';
export function getSystemName() {
  let system_name = localStorage.getItem('system_name');
  if (!system_name) return 'PerfXCloud';
  return system_name;
}

export function isMobile() {
  return window.innerWidth <= 600;
}

// eslint-disable-next-line
export function SnackbarHTMLContent({ htmlContent }) {
  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
}

export function getSnackbarOptions(variant) {
  let options = snackbarConstants.Common[variant];
  if (isMobile()) {
    // 合并 options 和 snackbarConstants.Mobile
    options = { ...options, ...snackbarConstants.Mobile };
  }
  return options;
}

export function showError(error, showTip = true) {
  if (error.message) {
    if (error.name === 'AxiosError') {
      switch (error.response.status) {
        case 429:
          enqueueSnackbar(t('error_too_many_requests'), getSnackbarOptions('ERROR'));
          break;
        case 500:
          enqueueSnackbar(t('internal_server_error'), getSnackbarOptions('ERROR'));
          break;
        case 405:
          enqueueSnackbar('本站仅作演示之用，无服务端！', getSnackbarOptions('INFO'));
          break;
        default:
          enqueueSnackbar((showTip ? t('error') : '') + error.message, getSnackbarOptions('ERROR'));
      }
      return;
    }
  } else {
    enqueueSnackbar((showTip ? t('error') : '') + error, getSnackbarOptions('ERROR'));
  }
}

export function showNotice(message, isHTML = false) {
  if (isHTML) {
    enqueueSnackbar(<SnackbarHTMLContent htmlContent={message} />, getSnackbarOptions('NOTICE'));
  } else {
    enqueueSnackbar(message, getSnackbarOptions('NOTICE'));
  }
}

export function showWarning(message) {
  enqueueSnackbar(message, getSnackbarOptions('WARNING'));
}

export function showSuccess(message) {
  enqueueSnackbar(message, getSnackbarOptions('SUCCESS'));
}

export function showInfo(message) {
  enqueueSnackbar(message, getSnackbarOptions('INFO'));
}

export async function getOAuthState() {
  const res = await API.get('/api/oauth/state');
  const { success, message, data } = res.data;
  if (success) {
    return data;
  } else {
    showError(message);
    return '';
  }
}

export async function onGitHubOAuthClicked(github_client_id, openInNewTab = false, checked) {
  if (!checked) return showError(t('agree_to_terms'), false);
  const state = await getOAuthState();
  if (!state) return;
  let url = `https://github.com/login/oauth/authorize?client_id=${github_client_id}&state=${state}&scope=user:email`;
  if (openInNewTab) {
    window.open(url);
  } else {
    window.location.href = url;
  }
}

export async function onGoogleOAuthClicked(google_client_id, google_redirect_url, openInNewTab = false, checked) {
  if (!checked) return showError(t('agree_to_terms'), false);
  const state = await getOAuthState();
  if (!state) return;
  var clientId = google_client_id; // 你的 Google OAuth 客户端 ID
  var redirectUri = google_redirect_url; // 'https://perfxcloud.io/oauth/google'; // 重定向 URI
  var scope = 'email profile'; // 请求的权限范围，可以根据需求修改
  //var state = 'YOUR RTT_STATE'; // 用于防止跨站请求伪造（CSRF）攻击，可以不设置，可以随心设置
  var responseType = 'code'; // 授权响应类型，表示要求返回授权码
  //var clientSecret = 'you clientSecret '; //Google OAuth 客户端密钥（不是api密钥）
  var grantType = 'authorization_code';
  //&prompt=login 把它加到window.authUrl的末尾可以让用户每次都需要重新输入账号和密码
  var url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}&response_type=${responseType}`;
  //点击Google登录  执行这个方法进行跳转
  if (openInNewTab) {
    window.open(url);
  } else {
    window.location.href = url;
  }
}

export async function onLarkOAuthClicked(lark_client_id) {
  const state = await getOAuthState();
  if (!state) return;
  let redirect_uri = `${window.location.origin}/oauth/lark`;
  window.open(`https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${redirect_uri}&app_id=${lark_client_id}&state=${state}`);
}

export function isAdmin() {
  let user = localStorage.getItem('user');
  if (!user) return false;
  user = JSON.parse(user);
  return user.role >= 10;
}
export function isRoot() {
  let user = localStorage.getItem('user');
  if (!user) return false;
  user = JSON.parse(user);
  return user.role >= 100;
}
export function getUserInfo() {
  let user = localStorage.getItem('user');
  if (!user) return null;
  user = JSON.parse(user);
  return user;
}
export function timestamp2string(timestamp) {
  let date = new Date(timestamp * 1000);
  let year = date.getFullYear().toString();
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();
  let hour = date.getHours().toString();
  let minute = date.getMinutes().toString();
  let second = date.getSeconds().toString();
  if (month.length === 1) {
    month = '0' + month;
  }
  if (day.length === 1) {
    day = '0' + day;
  }
  if (hour.length === 1) {
    hour = '0' + hour;
  }
  if (minute.length === 1) {
    minute = '0' + minute;
  }
  if (second.length === 1) {
    second = '0' + second;
  }
  return year + '/' + month + '/  ' + day + ' ' + hour + ':' + minute + ':' + second;
}

export function calculateQuota(quota, digits = 4) {
  let quotaPerUnit = localStorage.getItem('quota_per_unit');
  quotaPerUnit = parseFloat(quotaPerUnit);
  return (quota / quotaPerUnit).toFixed(digits);
}

export function renderQuota(quota, digits = 2) {
  let displayInCurrency = localStorage.getItem('display_in_currency');
  displayInCurrency = displayInCurrency === 'true';

  if (displayInCurrency) {
    return calculateQuota(quota, digits);
  }
  return renderNumber(quota);
}

export const verifyJSON = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export function renderNumber(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + 'B';
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 10000) {
    return (num / 1000).toFixed(1) + 'k';
  } else {
    return num;
  }
}

export function renderQuotaWithPrompt(quota, digits) {
  let displayInCurrency = localStorage.getItem('display_in_currency');
  displayInCurrency = displayInCurrency === 'true';
  if (displayInCurrency) {
    return `（${t('equivalent_amount')}：${renderQuota(quota, digits)}）`;
  }
  return '';
}

export function downloadTextAsFile(text, filename) {
  let blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
  let url = URL.createObjectURL(blob);
  let a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
}

export function removeTrailingSlash(url) {
  if (url.endsWith('/')) {
    return url.slice(0, -1);
  } else {
    return url;
  }
}
export const formatDateTime = (timestamp, offset = 0, type = 'date') => {
  // 创建一个新的 Date 对象，使用给定的时间戳
  const date = new Date(timestamp);

  // 应用天数偏移量
  date.setDate(date.getDate() + offset);

  // 验证 Date 对象是否有效
  if (isNaN(date.getTime())) {
    return timestamp;
  }

  // 提取日期和时间的各个部分
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始，因此需要 +1，并确保两位数格式
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  // 格式化输出字符串
  const formattedDate = type == 'datetime' ? `${year}/${month}/${day} ${hours}:${minutes}:${seconds}` : `${year}/${month}/${day}`;
  return formattedDate;
};

// 使用示例：

export function copyToClipboard(text) {
  if (navigator.clipboard) {
    // 支持 navigator.clipboard 的环境
    return navigator.clipboard.writeText(text);
  } else {
    // 使用 document.execCommand 在不支持 navigator.clipboard 的环境下复制文本
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // 将 textarea 元素添加到 DOM 中
    document.body.appendChild(textArea);

    // 选中文本并执行复制命令
    textArea.select();
    document.execCommand('copy');

    // 移除 textarea 元素
    document.body.removeChild(textArea);

    // 返回 Promise 对象
    return Promise.resolve();
  }
}

export function getItemAriaLabel(type, page, selected, itemCount) {
  switch (type) {
    case 'first':
      return t('go_to_first_page');
    case 'last':
      return t('go_to_last_page');
    case 'next':
      return t('go_to_next_page');
    case 'previous':
      return t('go_to_previous_page');
    default:
      return '';
  }
}
export function isValidPhoneNumber(phone) {
  const phoneRegex = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  return phoneRegex.test(phone);
}
export const multiplyAndCeil = (number, multiple) => {
  return new Decimal(number)
    .times(new Decimal(multiple || 1))
    .ceil()
    .toNumber();
};
export const roundAndTwodecimal = (number) => {
  return Math.round(number * 100) / 100;
};

export const addNumbers = (num, offset) => {
  const result = new Decimal(num).plus(new Decimal(offset || 0));
  return Math.ceil(result.toNumber());
};
export function generateShortId(length = 8) {
  return Math.random().toString(36).substr(2, length);
}
export function getCurrentMonthAndDay(date) {
  // 获取当前日期对象
  const newDate = new Date(date);

  // 获取月份（0-11，0表示1月，11表示12月），加1使其范围为1-12
  const month = newDate.getMonth() + 1;

  // 获取日期（1-31）
  const day = newDate.getDate();

  // 返回包含月份和日期的对象
  return `${month}/${day}`;
}
